import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import Input from '../../components/form/input';

@observer
class EditSaleColor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            //    static get(type, section, skipFields = [], onlyFields = []) {
            sections: fields.get('sale', 'Sale basics', [], ['color']),
        };
    }


    render() {
        const { week, isNew, drawerLevel, installation, lookupArray = 'sales' } = this.props;
        const { sections, showSimilar } = this.state;
        const { userStore, saleStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        // const { newNews, foundList, foundListKeys } = saleStore;
        // const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center position-relative'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>
                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newCustomer, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(installation, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        <Text id='sale.edit'>Edit sale</Text>
                    </div>

                    <div class='w-100 d-flex flex-column justify-content-start'>
                        <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                            <FormFields
                                stores={this.props.stores}
                                sections={sections}
                                holdingStore={saleStore}
                                objectName={'newSale'}
                                drawerLevel={drawerLevel}
                                isAdmin={false}
                                lookupArray={lookupArray}
                                // rightHeader={isNew && foundList?.length > 0 ? <span class='text-success font-weight-bold'><i class='fa-solid fa-circle-info' /> Similar newss ({foundList.length})</span> : null}
                                // rightHeaderClick={this.toggleSimilar}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default EditSaleColor;
